import { IoMdMail } from 'react-icons/io';
import img1 from '../../assets/images/why-choose/why-choose-1.png'
import img2 from '../../assets/images/why-choose/why-choose-1.png'
import img3 from '../../assets/images/why-choose/why-choose-1.png'
import { BsFillInfoCircleFill } from "react-icons/bs";
import { FaDatabase } from "react-icons/fa";

import blog1 from '../../assets/images/blog/blog-1.jpg'




export const threeBoxData = [
    {
        imgSrc:img1,
        heading:'A Smart Urban Mobility Platform',
        content:'In the days before the Internet, selling a business was a slow but straightforward process: The buyer…',
        learnMore:'Learn More'
    },
    {
        imgSrc:img2,
        heading:'Air Freight Forwarders',
        content:'The activity of Air Freight Forwarding has been around for many years and there has been a recent resurgence…',
        learnMore:'Learn More'
    },
    {
        imgSrc:img3,
        heading:'Cargo Theft Statistics & Trends',
        content:'Cargo theft can occur anywhere along the supply chain, affecting local logistics, transporters, storage yards,…',
        learnMore:'Learn More'
    },
]

export const resourcesData = [
    {
        imgSrc:<IoMdMail />,
        heading:'Services',
        content:'Neque porro quisquam est, qui dolorem ipsum.',
        learn:'Learn More'
    },
    {
        imgSrc:<FaDatabase  />,
        heading:'Career',
        content:'Neque porro quisquam est, qui dolorem ipsum.',
        learn:'Learn More'
    },
    {
        imgSrc:<BsFillInfoCircleFill />,
        heading:'Leadership',
        content:'Neque porro quisquam est, qui dolorem ipsum.',
        learn:'Learn More'
    },
] 

export const blogData = [
    {
        imgSrc:blog1,
        date:'February 29, 2024',
        heading:'Logistics for Business Defined: Importance Role & Benefits',
        content:'The Importance of Logistics for Business is an important concept to understand if you\'re looking to increase profits and grow your company.'
    },
    {
        imgSrc:blog1,
        date:'February 29, 2024',
        heading:'Logistics for Business Defined: Importance Role & Benefits',
        content:'The Importance of Logistics for Business is an important concept to understand if you\'re looking to increase profits and grow your company.'
    },
    {
        imgSrc:blog1,
        date:'February 29, 2024',
        heading:'Logistics for Business Defined: Importance Role & Benefits',
        content:'The Importance of Logistics for Business is an important concept to understand if you\'re looking to increase profits and grow your company.'
    },
    {
        imgSrc:blog1,
        date:'February 29, 2024',
        heading:'Logistics for Business Defined: Importance Role & Benefits',
        content:'The Importance of Logistics for Business is an important concept to understand if you\'re looking to increase profits and grow your company.'
    },
    {
        imgSrc:blog1,
        date:'February 29, 2024',
        heading:'Logistics for Business Defined: Importance Role & Benefits',
        content:'The Importance of Logistics for Business is an important concept to understand if you\'re looking to increase profits and grow your company.'
    },
    {
        imgSrc:blog1,
        date:'February 29, 2024',
        heading:'Logistics for Business Defined: Importance Role & Benefits',
        content:'The Importance of Logistics for Business is an important concept to understand if you\'re looking to increase profits and grow your company.'
    }
]